import { useSelector } from 'react-redux';

import { multiCaseGet } from '../../libs/format';
import { getWebsiteUrl } from '../../libs/website';
import { selectBusiness } from '../../selectors';
import { selectDomains, selectIsNextWebsite, selectWebsite } from '../../selectors/website';

function useWebsite() {
  const business = useSelector(selectBusiness);
  const website = useSelector(selectWebsite);
  const domains = useSelector(selectDomains);
  const isNextWebsite = useSelector(selectIsNextWebsite);

  function getBaseWebsiteURL() {
    return getWebsiteUrl(business, website, domains, isNextWebsite);
  }

  function createWebsiteURL(slug) {
    const websiteUrl = getBaseWebsiteURL();
    return `${websiteUrl}${slug}`;
  }

  function getWebsiteStackStatus() {
    return multiCaseGet(website, 'stack_status');
  }

  return {
    getWebsiteStackStatus,
    getBaseWebsiteURL,
    createWebsiteURL,
  };
}

export default useWebsite;
